import React from 'react'

const NotFound = () => {
    return(
        <div className="container">
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="display-6 text-danger">
                    Page Not Found
                </div>
            </div>
        </div>
    )
}

export default NotFound